import { render, staticRenderFns } from "./GoogleRecaptcha.vue?vue&type=template&id=0e0985c1"
import script from "./GoogleRecaptcha.vue?vue&type=script&lang=js"
export * from "./GoogleRecaptcha.vue?vue&type=script&lang=js"
import style0 from "./GoogleRecaptcha.vue?vue&type=style&index=0&id=0e0985c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports